function isDefined(value) {
  return !(value === null || value === void 0);
}
function applyMultilineAddressSettings(form, settings, multilineAddressValidation) {
  if (!settings || !multilineAddressValidation) {
    return form;
  }
  return {
    ...form,
    fields: (form.fields ?? []).map((field) => {
      const { show, ...rest } = settings[field.target] || {};
      const { required } = multilineAddressValidation[field.target] || {};
      return {
        ...field,
        view: {
          ...field.view,
          ...rest
        },
        ...isDefined(show) && { hidden: !show },
        ...isDefined(required) && isDefined(field.validation) && {
          validation: {
            ...field.validation,
            required
            // TODO: Fix type
          }
        }
      };
    })
  };
}
export {
  applyMultilineAddressSettings
};
//# sourceMappingURL=apply-multiline-address-settings.js.map
